import styled from 'styled-components'

import Button from '../common/button'

const StyledButton = styled(Button)`
  align-items: center;
  border-radius: 0 6px 6px 0;
  display: flex;

  svg {
    fill: white;
  }
`

export default StyledButton
